import $ from 'jquery';

function typing() {
	var $container = $('.c-typing');

	$container.each(function() {
		var $typing = $(this).find('.c-typing_text');

		$typing.each(function(index) {
			var $width = $(this).outerWidth(false) + 20;
			$(this).css('width', $width);
			$(this).css('animation', 'typing 2s steps(22), blink .5s step-end infinite alternate');
			if( index != 0 ) {
				$(this).hide();
			}
	
			$(this).on('animationend webkitAnimationEnd', function() {
				if( $(this).is(":visible") ) {
					$(this).delay( 4000 ).fadeOut();
					$(this).next().delay( 4400 ).fadeIn();
					if( index === $typing.length - 1 ) {
						$typing.first().delay( 4400 ).fadeIn();
					}
				}
			});
		});
	});
}

export { typing };